import React, { useState } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Header.css";
import { Link } from "react-router-dom";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      {/* ====== Header ====== */}
      <Navbar expand="lg" className="header">
        <Navbar.Brand as={Link} to="/">
          <img src="/images/logo/new-logo.png" alt="Logo" width="150px" />
        </Navbar.Brand>

        {/* ✅ Explore / Close Button */}
        <button
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
        >
          <i
            className={`bi ${menuOpen ? "bi-x" : "bi-list"}`}
            style={{ fontSize: "36px" }}
          ></i>
          <p>EXPLORE</p>
        </button>
      </Navbar>

      {/* ====== Sidebar Menu ====== */}
      <div className={`side-menu ${menuOpen ? "open" : ""}`}>
        <Nav>
          {/* Group Companies */}
          <NavDropdown title="Group Companies" id="group-dropdown">
            <NavDropdown.Item as={Link} to="/innovative-solution-technologies">
              Innovative Solution Technologies
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/digital-india-leader">
              Digital India Leader
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/iidts">
              Indian Institute of Digital Transformations
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/thirsty-hunter">
              Thirsty Hunter
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/book-you-online">
              Book You Online
            </NavDropdown.Item>
          </NavDropdown>

          {/* Solutions & Services */}
          <NavDropdown title="Solutions & Services" id="solutions-dropdown">
            <NavDropdown.Item as={Link} to="/business-technology-solutions">
              Business Technology
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/digital-marketing-solutions">
              Digital Marketing
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/digital-payment-solutions">
              Digital Payments
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/business-process-management">
              Business Process Management
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/cloud-infra-solutions">
              Cloud Infrastructure
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/technology-digital-consulting">
              Tech Digital Consulting
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/ai-analytics">
              AI & Analytic Solutions
            </NavDropdown.Item>
          </NavDropdown>

          {/* Industries */}
          <NavDropdown title="Industries" id="industries-dropdown">
            <NavDropdown.Item as={Link} to="/healthcare-medical-solutions">
              Healthcare & Medical
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/travel-hospitality-solutions">
              Travel & Hospitality
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/publishing">
              Publishing
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/ecommerce-retail-solutions">
              eCommerce & Retail
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/banking-finance-solutions">
              Banking & Fintech
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/manufacturing-industry-solutions">
              Manufacturing & Tech
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/government-publicsector-solutions">
              Government & Public Sector
            </NavDropdown.Item>
          </NavDropdown>

          {/* Discover ISOLS */}
          <NavDropdown title="Discover ISOLS" id="discover-isols-dropdown">
            <NavDropdown.Item as={Link} to="/about-isolsgroup">
              About ISOLS Group
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/about-isolsgroup#mission-vision-values">
              Mission, Vision & Values
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/award-certifications">
              Awards & Recognitions
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/careers">
              Careers
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/vibrant-culture">
              Life @ISOLS
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/csr">
              CSR
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/media-releases">
              Media
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/investor-relations">
              Investors Relations
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/testimonial">
              Testimonials
            </NavDropdown.Item>
          </NavDropdown>

          {/* Products */}
          <NavDropdown title="Products" id="products-dropdown">
            <NavDropdown.Item as={Link} to="https://cutts.in/" target="_blank">
              URL Shortner
            </NavDropdown.Item>
            <NavDropdown.Item as={Link} to="https://chatup.in/" target="_blank">
              ChatUp
            </NavDropdown.Item>
            <NavDropdown.Item
              as={Link}
              to="https://crmlogin.co/public/"
              target="_blank"
            >
              True CRM
            </NavDropdown.Item>
          </NavDropdown>

          <Nav.Link as={Link} to="/clients">Clients</Nav.Link>
          <Nav.Link as={Link} to="/contact">Contact</Nav.Link>

          {/* Phone Section */}
          <div className="phone">
            <p>
              <Link to="tel:+919555411411">+91-9555-411-411</Link>
            </p>
            <p>
              <Link to="tel:+14373768000">+1 (437) 376 8000</Link>
            </p>
          </div>
        </Nav>
      </div>
    </>
  );
};

export default Header;
